import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { ArrowRight, CheckCircle2, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
export function ServicesPage() {
  const {
    t,
    lang,
    getArray
  } = useTranslation();
  const services = [{
    id: 'fillings',
    title: t('services.fillings.title'),
    description: t('services.fillings.fullDesc'),
    benefits: getArray('services.fillings.benefits'),
    image: 'https://images.pexels.com/photos/3845766/pexels-photo-3845766.jpeg?auto=compress&cs=tinysrgb&w=800'
  }, {
    id: 'root-canal',
    title: t('services.rootCanal.title'),
    description: t('services.rootCanal.fullDesc'),
    benefits: getArray('services.rootCanal.benefits'),
    image: 'https://images.pexels.com/photos/3881449/pexels-photo-3881449.jpeg?auto=compress&cs=tinysrgb&w=800'
  }, {
    id: 'crowns',
    title: t('services.crowns.title'),
    description: t('services.crowns.fullDesc'),
    benefits: getArray('services.crowns.benefits'),
    image: 'https://images.pexels.com/photos/3845625/pexels-photo-3845625.jpeg?auto=compress&cs=tinysrgb&w=800'
  }, {
    id: 'hygiene',
    title: t('services.hygiene.title'),
    description: t('services.hygiene.fullDesc'),
    benefits: getArray('services.hygiene.benefits'),
    image: 'https://images.pexels.com/photos/3845653/pexels-photo-3845653.jpeg?auto=compress&cs=tinysrgb&w=800'
  }, {
    id: 'whitening',
    title: t('services.whitening.title'),
    description: t('services.whitening.fullDesc'),
    benefits: getArray('services.whitening.benefits'),
    image: 'https://images.pexels.com/photos/3762453/pexels-photo-3762453.jpeg?auto=compress&cs=tinysrgb&w=800'
  }, {
    id: 'extraction',
    title: t('services.extraction.title'),
    description: t('services.extraction.fullDesc'),
    benefits: getArray('services.extraction.benefits'),
    image: 'https://images.pexels.com/photos/3845810/pexels-photo-3845810.jpeg?auto=compress&cs=tinysrgb&w=800'
  }, {
    id: 'smile-makeover',
    title: t('services.smileMakeover.title'),
    description: t('services.smileMakeover.fullDesc'),
    benefits: getArray('services.smileMakeover.benefits'),
    image: 'https://images.pexels.com/photos/3985163/pexels-photo-3985163.jpeg?auto=compress&cs=tinysrgb&w=800'
  }, {
    id: 'cosmetic',
    title: t('services.cosmetic.title'),
    description: t('services.cosmetic.fullDesc'),
    benefits: getArray('services.cosmetic.benefits'),
    image: 'https://images.pexels.com/photos/3764013/pexels-photo-3764013.jpeg?auto=compress&cs=tinysrgb&w=800'
  }];
  return <Layout data-id="element-399">
      <div className="bg-teal-900 py-20 text-white" data-id="element-400">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-401">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-402">
            {t('servicesPage.title')}
          </h1>
          <p className="text-xl text-teal-100 max-w-2xl mx-auto" data-id="element-403">
            {t('servicesPage.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 space-y-24" data-id="element-404">
        {services.map((service, index) => <div key={service.id} className={`flex flex-col gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'}`} data-id="element-405">
            <div className="flex-1 w-full" data-id="element-406">
              <Link to={`/${lang}/services/${service.id}`} className="block group" data-id="element-407">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-408">
                  <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-409" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" data-id="element-410" />
                </div>
              </Link>
            </div>

            <div className="flex-1 space-y-6" data-id="element-411">
              <Link to={`/${lang}/services/${service.id}`} className="block group" data-id="element-412">
                <h2 className="text-3xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors" data-id="element-413">
                  {service.title}
                </h2>
              </Link>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-414">
                {service.description}
              </p>

              <ul className="space-y-3" data-id="element-415">
                {service.benefits.map((benefit, idx) => <li key={idx} className="flex items-center gap-3 text-gray-700" data-id="element-416">
                    <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-417" />
                    <span data-id="element-418">{benefit}</span>
                  </li>)}
              </ul>

              <div className="pt-4 flex flex-wrap gap-4" data-id="element-419">
                <Link to={`/${lang}/services/${service.id}`} data-id="element-420">
                  <Button className="gap-2" data-id="element-421">
                    {t('services.learnMore')} <ArrowRight className="w-4 h-4" data-id="element-422" />
                  </Button>
                </Link>
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-423">
                  <Button variant="outline" className="gap-2" data-id="element-424">
                    {t('servicesPage.bookConsultation')}
                  </Button>
                </a>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-gray-50 py-20" data-id="element-425">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-426">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-427">
            {t('servicesPage.readyToBook')}
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-428">
            {t('servicesPage.readyToBookDesc')}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-429">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-430">
              <Button size="lg" className="gap-2 w-full sm:w-auto" data-id="element-431">
                <Calendar className="w-5 h-5" data-id="element-432" />
                {t('servicesPage.bookOnlineNow')}
              </Button>
            </a>
            <Link to={`/${lang}/contact`} data-id="element-433">
              <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-434">
                {t('servicesPage.contactUs')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>;
}